import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class RequestsForApprovalService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'FourEyesService');
  }

  public approveRequest(requestId) {
    let serviceUrl = this.baseUrl + this.serviceName + '/approveRequest';
    return this.request(serviceUrl, this.setPostParams(requestId)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  public rejectRequest(rejectionRequest) {
    let serviceUrl = this.baseUrl + this.serviceName + '/rejectRequest';
    return this.request(serviceUrl, this.setPostParams(rejectionRequest)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
  public rejectByMakerRequest(requestId) {
    let serviceUrl = this.baseUrl + this.serviceName + '/rejectByMakerRequest';
    return this.request(serviceUrl, this.setPostParams(requestId)).pipe(
      map(super.extractData),
      catchError(super.handleError),
    );
  }
}
